module.exports = __webpack_public_path__ + "element-icons.woff?d2f69a92faa6fe990d2e613c358be705";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/style/element-theme/fonts/element-icons.woff?t=1472440741
// module id = 251
// module chunks = 0